import React,{useState} from "react";
import "./courses.scss";
import CourseCard from "./CourseCard/CourseCard.jsx"
import Carousel from 'react-bootstrap/Carousel';

export default function Courses(){

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    selectedIndex >= 2 ? setIndex(0) : setIndex(selectedIndex);
  };

  const c1l1="30 hours of IELTS Live Classes";
  const c1l2="Full Length and 80 sectional Practice Tests";
  const c1l3="Personalised feedback and doubt solving";
  const c1l4="Cambridge Study Material & Class Recordings";

  const c2l1="15 hours of IELTS Live Classes";
  const c2l2="Latest Tips & Techniques";
  const c2l3="Supplementary Material for Vocabulary Idioms & Grammar";
  const c2l4="5 Full Length Mock Tests with Performance Ananlysis";

  const c3l1="15 hours of IELTS Live Classes";
  const c3l2="Skill Oriented Sessions & Practice";
  const c3l3="Cambridge Study Material & Class Recordings";
  const c3l4="30 Computerised Sectionals Tests with Performance Ananlysis";

  return(
    <div className="courses" id="courses">
    <div className="Headerwithbtn">
    <div className="Courses-heading">Our Top IELTS Preparation Courses</div>
    <div className="sliderbuttons">
    <button className="prevBtn" id="prevBtn"  onClick={() =>
            index === 0
              ? setIndex(2)
              : setIndex(index - 1)
          }>&lt;</button>
    <button className="nextBtn" id="nextBtn" onClick={() =>
            index === 2
              ? setIndex(0)
              : setIndex(index + 1)
          }>&gt;</button>
    </div>
    </div>
    <div className="Courses-slider">
    <Carousel activeIndex={index} onSelect={handleSelect}>.
    <Carousel.Item >
    <div className="courses-block">
    <CourseCard endImage="350+ Enrollments" image="/assets/iletsregular.png" smallHeading="IELTS Regular" CCHeading="Comprehensive IELTS Program" line1={c1l1} line2={c1l2} line3={c1l3} line4={c1l4}/>
    <CourseCard endImage="400+ Enrollments" image="/assets/iletscrash.png" smallHeading="IELTS Fast-track" CCHeading="IELTS Crash Course" line1={c2l1} line2={c2l2} line3={c2l3} line4={c2l4}/>
    <CourseCard endImage="300+ Enrollments" image="/assets/iletsskillbased.png" smallHeading="IELTS Sectional" CCHeading="IELTS Skill based program" line1={c3l1} line2={c3l2} line3={c3l3} line4={c3l4}/>
    </div>
    </Carousel.Item >
    <Carousel.Item >
    <div className="courses-block">
    <CourseCard endImage="350+ Enrollments" image="/assets/iletsregular.png" smallHeading="IELTS Regular" CCHeading="Comprehensive IELTS Program" line1={c1l1} line2={c1l2} line3={c1l3} line4={c1l4}/>
    <CourseCard endImage="400+ Enrollments" image="/assets/iletscrash.png" smallHeading="IELTS Fast-track" CCHeading="IELTS Crash Course" line1={c2l1} line2={c2l2} line3={c2l3} line4={c2l4}/>
    <CourseCard endImage="300+ Enrollments" image="/assets/iletsskillbased.png" smallHeading="IELTS Sectional" CCHeading="IELTS Skill based program" line1={c3l1} line2={c3l2} line3={c3l3} line4={c3l4}/>
    </div>
    </Carousel.Item >
    <Carousel.Item >
    <div className="courses-block">
    <CourseCard endImage="350+ Enrollments" image="/assets/iletsregular.png" smallHeading="IELTS Regular" CCHeading="Comprehensive IELTS Program" line1={c1l1} line2={c1l2} line3={c1l3} line4={c1l4}/>
    <CourseCard endImage="400+ Enrollments" image="/assets/iletscrash.png" smallHeading="IELTS Fast-track" CCHeading="IELTS Crash Course" line1={c2l1} line2={c2l2} line3={c2l3} line4={c2l4}/>
    <CourseCard endImage="300+ Enrollments" image="/assets/iletsskillbased.png" smallHeading="IELTS Sectional" CCHeading="IELTS Skill based program" line1={c3l1} line2={c3l2} line3={c3l3} line4={c3l4}/>
    </div>
    </Carousel.Item >
     </Carousel>
     </div>
    </div>
  )
}
